import React from 'react';
import './BlogSkeleton.css';

export const FeaturedSkeleton = () => (
  <div className="featured-posts-grid" aria-hidden="true">
    {Array.from({ length: 3 }).map((_, index) => (
      <div key={index} className="blog-skel-card">
        <div className="blog-skel-row">
          <span className="blog-skel blog-skel-line short" />
          <span className="blog-skel blog-skel-line short" />
        </div>
        <span className="blog-skel blog-skel-image" />
        <span className="blog-skel blog-skel-line" />
        <span className="blog-skel blog-skel-line medium" />
        <div className="blog-skel-row">
          <span className="blog-skel blog-skel-avatar" />
          <span className="blog-skel blog-skel-line short" />
        </div>
      </div>
    ))}
  </div>
);

export const LatestSkeleton = () => (
  <div className="latest-posts-grid" aria-hidden="true">
    {Array.from({ length: 6 }).map((_, index) => (
      <div key={index} className="blog-skel-latest">
        <div className="blog-skel-row">
          <span className="blog-skel blog-skel-line short" />
          <span className="blog-skel blog-skel-line short" />
        </div>
        <div className="blog-skel-latest-body">
          <span className="blog-skel blog-skel-thumb" />
          <div className="blog-skel-latest-text">
            <span className="blog-skel blog-skel-line" />
            <span className="blog-skel blog-skel-line medium" />
          </div>
        </div>
      </div>
    ))}
  </div>
);

export const BlogDetailsSkeleton = () => (
  <div className="blog-skel-details" aria-hidden="true">
    <span className="blog-skel blog-skel-line short" />
    <span className="blog-skel blog-skel-title" />
    <div className="blog-skel-row spaced">
      <span className="blog-skel blog-skel-line short" />
      <span className="blog-skel blog-skel-line medium" />
    </div>
    <div className="blog-skel-row">
      <span className="blog-skel blog-skel-avatar" />
      <span className="blog-skel blog-skel-line short" />
    </div>
    <span className="blog-skel blog-skel-hero" />
    <div className="blog-skel-details-body">
      <span className="blog-skel blog-skel-line" />
      <span className="blog-skel blog-skel-line" />
      <span className="blog-skel blog-skel-line medium" />
      <span className="blog-skel blog-skel-line" />
      <span className="blog-skel blog-skel-line medium" />
    </div>
  </div>
);

export const RelatedSkeleton = () => <FeaturedSkeleton />;
